import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { DataSheetGrid, textColumn, keyColumn } from "react-datasheet-grid";

// material components
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import "react-datasheet-grid/dist/style.css";
import "./DataTable.css";

import {
  setColumns,
  setData,
  setDocumentId,
} from "../../features/datatable/dataTableSlice";
import useSaveDocument from "../../hooks/useSaveDocument";
import {
  convertMinutesToMilliSeconds,
  deleteSheet,
  patchNewSheet,
} from "../../utils/variables";

// for setting initial columns to A-Z
const initialColumns = [];
for (let i = 65; i <= 90; i++) {
  const letter = String.fromCharCode(i);
  initialColumns.push({ ...keyColumn(letter, textColumn), title: letter });
}

const DataTable = ({
  action,
  title,
  sheetArray,
  setSheetArray,
  selectedSheet,
}) => {
  //params
  const { documentId } = useParams();
  const { saveDocument } = useSaveDocument();
  //redux states
  const { data } = useSelector((state) => state.dataTable);
  const dispatch = useDispatch();

  //local states
  const [columns, setColumns] = useState(initialColumns);
  // const [letter, setLetter] = useState("D");
  const [columnsInput, setColumnsInput] = useState(1);
  const [charCode, setCharCode] = useState(97);

  //redux state cleanup
  useEffect(() => {
    dispatch(setDocumentId(documentId));
  }, [dispatch, documentId]);

  //saving document
  useEffect(() => {
    const autoSave = setTimeout(saveDocument, convertMinutesToMilliSeconds(5));

    return () => {
      clearTimeout(autoSave);
    };
  }, [saveDocument]);

  //functions
  const handleDataChange = (payload) => {
    dispatch(setData(payload));
  };
  const handleDelete = async () => {
    if (sheetArray.length <= 0) return;

    const sheetSet = new Set(sheetArray);

    sheetSet.forEach(async (sheet) => {
      if (sheet.page === selectedSheet) {
        await deleteSheet(sheet.id);
        sheetSet.delete(sheet);
      }
    });

    const array = Array.from(sheetSet);
    setSheetArray(array);

    await patchNewSheet(array);
  };

  const onChangeColumnCount = () => {
    let colArray = columns;
    let nextCol;
    for (let index = 0; index < columnsInput; index++) {
      nextCol = String.fromCharCode(charCode + index);
      colArray.push({ ...keyColumn(nextCol, textColumn), title: nextCol });
    }

    setCharCode(nextCol.charCodeAt(0) + 1);
    setColumns(colArray);
  };

  return (
    <>
      <h2
        style={{
          color: "#777777",
        }}
      >
        Data Table
      </h2>
      <Box
        sx={{
          backgroundColor: "white",
          padding: "10px",
          borderRadius: "10px",
          marginTop: "10px",
          height: "auto",
        }}
      >
        <DataSheetGrid
          // key={columns}
          value={data}
          onChange={handleDataChange}
          columns={columns}
          rowHeight={30}
        />

        <div className="table-actions-container">
          <div className="table-buttons-column">
            <button
              type="button"
              className="dsg-add-row-btn"
              onClick={() => onChangeColumnCount()}
            >
              Add
            </button>
            <input
              className="dsg-add-row-input"
              type="number"
              min="1"
              value={columnsInput}
              onChange={(e) => setColumnsInput(e.target.value)}
            ></input>
            columns
          </div>
          <div
            style={{
              width: "100%",
            }}
          >
            <IconButton
              edge="start"
              onClick={action}
              aria-label="close"
              className="icon_button"
              style={{
                fontSize: "15px",
                float: "right",
                textDecoration: "none",
              }}
            >
              {title === "Enlarge view" ? (
                <FullscreenIcon />
              ) : (
                <FullscreenExitIcon />
              )}
              {" " + title}
            </IconButton>
            <IconButton
              edge="start"
              onClick={handleDelete}
              aria-label="close"
              className="table-buttons-delete icon_button"
            >
              <DeleteForeverIcon style={{ cursor: "pointer" }} />
              Delete Sheet
            </IconButton>
          </div>
        </div>
      </Box>
    </>
  );
};

export default DataTable;
